import * as errors from '@attain-apps/errors'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * Executes api request to get page rendering information
 */
export const getPageRenderOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.render.request.observe().pipe(
    rxjs.mergeMap(action => {
      const {
        data: { request },
      } = action
      // We get the page info using the API
      const render$ = feature.api.render(request)
      // NOTE: Mosaic developers are allowed to return `undefined` when they
      // want to have an empty rendering
      return render$.pipe(
        // Handles success
        rxjs.map((rendering = {}) =>
          feature.actions.render.success
            .from('getPageRenderOnRequest (effect)')
            .create({
              request: action.data,
              response: { rendering },
            }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.render.error
              .from('getPageRenderOnRequest (effect)')
              .create({
                error,
                request: action.data,
              }),
          ),
        ),
      )
    }),
  ),
)
